<template>
  <div id="priceAdjustments">
    <PageTitle :title="$t('pos.price_adjustments')" :subtitle="$t('pos.price_adjustments_description')"></PageTitle>
    <div class="container">
      <Panel :showTitle="false">
        <Datatable entity="sale_item_price_change" :parameters="parameters"></Datatable>
      </Panel>
    </div>
  </div>
</template>

<script>
  import Datatable from "@/components/Datatable.vue";
  import PageTitle from '@/components/PageTitle.vue';

  export default {
    name: "PriceAdjustments",
    components: { Datatable, PageTitle },
    data() {
      return {
        parameters: {
          company: this.$route.query.company
        }
      };
    }
  };
</script>
